import axios from "axios";

export default function updateCompanyExpiredDate({
  id,
  expiredAt,
  deactivateDate,
}) {
  return new Promise((resolve, reject) =>
    axios
      .put(`/account/system-admin/api/v1/company/${id}/update-expired-date`, {
        expired_at: expiredAt,
        deactivate_date: deactivateDate,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
